import axios from "axios";
// import { READ_API } from "../../backend";

export const getTds = () => {
  return axios
    .get(
      `https://api.thingspeak.com/channels/1464712/fields/1.json?api_key=YCILN56Q2KBFOW8F&results=1&location=false&round=2`
    )
    .then((response) => response.data)
    .catch((err) => console.error(err));
};

export const getWaterTemperature = () => {
  return axios
    .get(
      `https://api.thingspeak.com/channels/1464712/fields/2.json?api_key=YCILN56Q2KBFOW8F&results=1&location=false&round=2`
    )
    .then((response) => response.data)
    .catch((err) => console.error(err));
};

// export const getSystemStatus = () => {
//   return axios
//     .get(
//       `https://api.thingspeak.com/channels/1464712/fields/3.json?api_key=YCILN56Q2KBFOW8F&results=1&location=false&round=0`
//     )
//     .then((response) => response.data)
//     .catch((err) => console.error(err));
// };
